import React, { useState } from "react";
import Navbar from "../components/Navbar";

// Koordinatlar: SVG viewBox="0 0 900 420" baz alınarak gerçek dünya konumlarına göre ayarlandı
// posX/posY = yüzde cinsinden, birbirinden en az %12 uzakta
const IHLALLER = [
  {
    id:1, company:"LinkedIn", year:2012, icon:"💼", affected:"117 Milyon",
    leakedData:["E-posta","Şifre (hash)"],
    risk:"Credential Stuffing — aynı şifre başka platformlarda deneniyor.",
    protection:["Her platform için farklı şifre","2FA aktif et"],
    country:"ABD (Sunnyvale, CA)", color:"#0ea5e9",
    posX:"10%", posY:"34%",  // Batı ABD kıyısı
  },
  {
    id:2, company:"Adobe", year:2013, icon:"🎨", affected:"153 Milyon",
    leakedData:["E-posta","Şifreli parola","Kredi kartı ipucu"],
    risk:"Sızdırılan şifreler diğer platformlarda Credential Stuffing için kullanıldı.",
    protection:["Güçlü şifre kullan","2FA aktif et","Şifreni değiştir"],
    country:"ABD (San Jose, CA)", color:"#f87171",
    posX:"10%", posY:"48%",  // Batı ABD — LinkedIn'in altında, yeterli mesafe
  },
  {
    id:3, company:"Yahoo", year:2016, icon:"🟣", affected:"3 Milyar",
    leakedData:["Ad","E-posta","Telefon","Doğum tarihi","Güvenlik sorusu"],
    risk:"Tarihte en büyük veri ihlali. Kişisel bilgiler sosyal mühendislik saldırılarında kullanıldı.",
    protection:["E-posta şifreni değiştir","2FA aktif et","Güvenlik sorularını güncelle"],
    country:"ABD (Sunnyvale, CA)", color:"#a78bfa",
    posX:"22%", posY:"28%",  // Doğu ABD — New York bölgesi
  },
  {
    id:4, company:"Dropbox", year:2012, icon:"📦", affected:"68 Milyon",
    leakedData:["E-posta","Şifre (hash)"],
    risk:"Sızdırılan hesaplar 2016'ya kadar dark web'de satıldı.",
    protection:["Parolayı değiştir","2FA aktif et"],
    country:"ABD (San Francisco, CA)", color:"#34d399",
    posX:"22%", posY:"44%",  // Orta ABD
  },
  {
    id:5, company:"Facebook", year:2019, icon:"👤", affected:"530 Milyon",
    leakedData:["Telefon numarası","Ad","E-posta","Konum"],
    risk:"Telefon numaraları SIM-swap ve sosyal mühendislik için kullanıldı.",
    protection:["Gizlilik ayarlarını kontrol et","2FA aktif et","Telefon numarasını gizle"],
    country:"ABD (Menlo Park, CA)", color:"#60a5fa",
    posX:"16%", posY:"60%",  // Güney ABD — diğerlerinden uzak
  },
  {
    id:6, company:"Canva", year:2019, icon:"🎭", affected:"137 Milyon",
    leakedData:["Ad","E-posta","Şehir","Şifre (hash)"],
    risk:"Sanatçı ve tasarımcıların hesapları Credential Stuffing ile hedef alındı.",
    protection:["Şifreni değiştir","2FA aktif et"],
    country:"Avustralya (Perth)", color:"#fbbf24",
    posX:"80%", posY:"68%",  // Avustralya
  },
  {
    id:7, company:"Twitter/X", year:2022, icon:"🐦", affected:"200 Milyon",
    leakedData:["E-posta","Telefon (eşleştirilmiş)"],
    risk:"E-postalar ve telefon numaraları birleştirilerek kimlik tespiti yapıldı.",
    protection:["E-posta gizliliğini güncelle","2FA aktif et"],
    country:"ABD (San Francisco, CA)", color:"#38bdf8",
    posX:"48%", posY:"28%",  // Avrupa/İrlanda (Twitter EU sunucuları)
  },
];

export default function VeriIhlalHaritasi() {
  const [aktif, setAktif] = useState(null);
  const [kazanilan, setKazanilan] = useState([]);

  const tikla = (ihial) => {
    setAktif(ihial);
    if (!kazanilan.includes(ihial.id)) setKazanilan(p => [...p, ihial.id]);
  };

  return (
    <div style={{ minHeight:"100vh", background:"#0a0a0f", fontFamily:"'Sora',sans-serif", color:"#fff" }}>
      <Navbar />
      <style>{`
        @keyframes ping{0%{transform:scale(1);opacity:0.8}100%{transform:scale(2.8);opacity:0}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
        .dot-wrap{cursor:pointer;}
        .dot-wrap:hover .dot-inner{transform:scale(1.4);}
        .dot-label{opacity:0;transition:opacity .2s;}
        .dot-wrap:hover .dot-label{opacity:1;}
      `}</style>

      <div style={{ maxWidth:"960px", margin:"0 auto", padding:"2rem" }}>
        {/* Başlık */}
        <div style={{ textAlign:"center", marginBottom:"1.5rem" }}>
          <div style={{ fontSize:"2.5rem", marginBottom:"0.4rem" }}>🌍</div>
          <h1 style={{ margin:0, fontSize:"1.9rem", fontWeight:"800", background:"linear-gradient(90deg,#f87171,#fbbf24)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>
            Küresel Veri İhlali Haritası
          </h1>
          <p style={{ color:"#94a3b8", marginTop:"0.35rem" }}>Noktalara tıkla, veri ihlallerini keşfet!</p>
          <div style={{ marginTop:"0.6rem", color:"#fbbf24", fontSize:"0.85rem" }}>
            İncelenen: {kazanilan.length}/{IHLALLER.length} 🔍
            {kazanilan.length >= 3 && <span style={{ marginLeft:"0.5rem" }}>🏅 Farkındalık Rozeti</span>}
            {kazanilan.length >= IHLALLER.length && <span style={{ marginLeft:"0.5rem" }}>🏆 Siber Farkındalık Uzmanı!</span>}
          </div>
        </div>

        {/* Harita */}
        <div style={{ position:"relative", background:"linear-gradient(180deg,#0a1628 0%,#0d2240 50%,#0a1628 100%)", border:"1px solid #1e3a5f", borderRadius:"20px", overflow:"hidden", marginBottom:"1.5rem", height:"360px" }}>

          {/* SVG dünya haritası + noktalar */}
          <svg viewBox="0 0 900 360" width="100%" height="100%" style={{ position:"absolute", inset:0 }}>
            {/* Grid */}
            <g opacity="0.06">
              {Array.from({length:12}).map((_,i) => <line key={`v${i}`} x1={i*75} y1="0" x2={i*75} y2="360" stroke="#60a5fa" strokeWidth="1"/>)}
              {Array.from({length:8}).map((_,i)  => <line key={`h${i}`} x1="0" y1={i*45} x2="900" y2={i*45} stroke="#60a5fa" strokeWidth="1"/>)}
            </g>

            {/* Kıta siluetleri — daha gerçekçi şekiller */}
            <g fill="#1e3a5f" opacity="0.55">
              {/* Kuzey Amerika */}
              <polygon points="60,40 180,35 210,60 195,90 175,130 145,160 110,170 80,150 55,110 45,75"/>
              {/* Güney Amerika */}
              <polygon points="155,185 210,178 230,210 235,260 215,310 185,325 160,305 145,265 148,220"/>
              {/* Avrupa */}
              <polygon points="380,40 450,35 470,60 460,95 430,110 395,108 370,85 372,58"/>
              {/* Afrika */}
              <polygon points="385,120 462,115 490,160 495,230 465,285 430,300 395,285 370,235 368,170"/>
              {/* Asya (geniş) */}
              <polygon points="465,35 750,30 780,70 770,130 720,155 600,158 490,145 465,100"/>
              {/* Avustralya */}
              <polygon points="680,245 775,238 800,270 798,305 765,322 715,318 685,295 672,268"/>
              {/* Japonya (küçük) */}
              <ellipse cx="785" cy="105" rx="18" ry="28" transform="rotate(-15,785,105)"/>
            </g>

            {/* İhlal noktaları */}
            {IHLALLER.map(ihial => {
              const x = parseFloat(ihial.posX) * 9;  // %→px (viewBox 900)
              const y = parseFloat(ihial.posY) * 3.6; // %→px (viewBox 360)
              const isActive = aktif?.id === ihial.id;
              const isSeen = kazanilan.includes(ihial.id);
              return (
                <g key={ihial.id} className="dot-wrap" onClick={() => tikla(ihial)} style={{ cursor:"pointer" }}>
                  {/* Ping halkası */}
                  <circle cx={x} cy={y} r="14" fill={ihial.color} opacity="0.15">
                    <animate attributeName="r" values="8;18;8" dur="2s" repeatCount="indefinite"/>
                    <animate attributeName="opacity" values="0.3;0;0.3" dur="2s" repeatCount="indefinite"/>
                  </circle>
                  {/* Ana nokta */}
                  <circle cx={x} cy={y} r={isActive ? 10 : 7} fill={ihial.color}
                    stroke={isActive ? "#fff" : isSeen ? "#ffffff88" : "transparent"}
                    strokeWidth={isActive ? 2.5 : 1.5}
                    style={{ transition:"r .2s, stroke .2s", filter:`drop-shadow(0 0 6px ${ihial.color})` }}>
                    <animate attributeName="r" values={isActive?"10;10":"7;8;7"} dur="1.5s" repeatCount="indefinite"/>
                  </circle>
                  {/* Şirket etiketi */}
                  <g transform={`translate(${x},${y-16})`} className="dot-label">
                    <rect x="-32" y="-14" width="64" height="16" rx="5" fill="rgba(0,0,0,0.85)"/>
                    <text textAnchor="middle" y="-3" fill="#fff" fontSize="9" fontFamily="Sora,sans-serif" fontWeight="600">
                      {ihial.icon} {ihial.company}
                    </text>
                  </g>
                  {/* Aktifse her zaman göster */}
                  {isActive && (
                    <g transform={`translate(${x},${y-16})`}>
                      <rect x="-32" y="-14" width="64" height="16" rx="5" fill="rgba(0,0,0,0.9)"/>
                      <text textAnchor="middle" y="-3" fill={ihial.color} fontSize="9" fontFamily="Sora,sans-serif" fontWeight="700">
                        {ihial.icon} {ihial.company}
                      </text>
                    </g>
                  )}
                </g>
              );
            })}
          </svg>

          {/* Legend */}
          <div style={{ position:"absolute", bottom:"12px", right:"14px", background:"rgba(0,0,0,0.7)", borderRadius:"10px", padding:"0.45rem 0.8rem", fontSize:"0.7rem", color:"#94a3b8", display:"flex", alignItems:"center", gap:"0.4rem" }}>
            <span style={{ display:"inline-block", width:"10px", height:"10px", borderRadius:"50%", background:"#ef4444", boxShadow:"0 0 6px #ef4444" }}/>
            Veri İhlali Noktası
          </div>
        </div>

        {/* Seçili kart */}
        {aktif ? (
          <div style={{ background:"rgba(255,255,255,0.04)", border:`2px solid ${aktif.color}44`, borderRadius:"20px", padding:"1.75rem", animation:"fadeUp .4s ease", boxShadow:`0 0 30px ${aktif.color}22` }}>
            <div style={{ display:"flex", alignItems:"center", gap:"0.75rem", marginBottom:"1rem" }}>
              <span style={{ fontSize:"2rem" }}>{aktif.icon}</span>
              <div>
                <div style={{ fontWeight:"800", fontSize:"1.2rem", color:aktif.color }}>{aktif.company} Veri İhlali</div>
                <div style={{ color:"#64748b", fontSize:"0.82rem" }}>📅 {aktif.year} · 👥 {aktif.affected} hesap etkilendi · 📍 {aktif.country}</div>
              </div>
            </div>

            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"1rem" }}>
              <div>
                <div style={{ color:"#94a3b8", fontSize:"0.75rem", fontWeight:"600", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:"0.4rem" }}>🛑 Sızan Bilgiler</div>
                {aktif.leakedData.map(d => <div key={d} style={{ color:"#fca5a5", fontSize:"0.85rem", marginBottom:"2px" }}>• {d}</div>)}
              </div>
              <div>
                <div style={{ color:"#94a3b8", fontSize:"0.75rem", fontWeight:"600", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:"0.4rem" }}>🛡️ Korunma Yöntemleri</div>
                {aktif.protection.map(p => <div key={p} style={{ color:"#86efac", fontSize:"0.85rem", marginBottom:"2px" }}>✅ {p}</div>)}
              </div>
            </div>

            <div style={{ marginTop:"1rem", background:"rgba(239,68,68,0.08)", border:"1px solid rgba(239,68,68,0.2)", borderRadius:"12px", padding:"0.75rem 1rem" }}>
              <div style={{ color:"#94a3b8", fontSize:"0.75rem", fontWeight:"600", textTransform:"uppercase", marginBottom:"0.3rem" }}>⚠️ Credential Stuffing Riski</div>
              <p style={{ color:"#fca5a5", fontSize:"0.88rem", margin:0, lineHeight:"1.6" }}>{aktif.risk}</p>
            </div>

            <div style={{ marginTop:"0.75rem", background:"rgba(59,130,246,0.08)", border:"1px solid rgba(59,130,246,0.2)", borderRadius:"12px", padding:"0.75rem 1rem" }}>
              <div style={{ color:"#60a5fa", fontSize:"0.8rem", fontWeight:"600", marginBottom:"0.35rem" }}>🔐 2FA Açık Olsaydı Ne Olurdu?</div>
              <div style={{ display:"flex", gap:"0.5rem", alignItems:"center", fontSize:"0.82rem", color:"#94a3b8", flexWrap:"wrap" }}>
                <span>🔓 Şifre doğru</span><span>→</span>
                <span style={{ color:"#f87171" }}>❌ 2FA başarısız</span><span>→</span>
                <span style={{ color:"#86efac" }}>🛡️ Hesap korundu</span>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ textAlign:"center", color:"#334155", padding:"2rem" }}>
            <div style={{ fontSize:"2rem", marginBottom:"0.5rem" }}>👆</div>
            <div>Haritadaki noktalara tıklayarak veri ihlallerini incele</div>
          </div>
        )}
      </div>
    </div>
  );
}
